export default __webpack_public_path__ + "media/images/front/municipality_collaboration/ishikawa/ogp-23fc3e5884669f9b2bcf040a71e36b09.png";